module.exports = __webpack_public_path__ + "static/media/gulfwarillness_image3.8171a2fe.jpg";